import { useState } from 'react';

/**
 * Keeps visual focus stable while a picker popover closes after selection.
 * The lock is released on real trigger blur.
 */
export const usePickerSelectionFocusLock = (open: boolean) => {
  const [isTriggerFocused, setIsTriggerFocused] = useState(false);
  const [isSelectionLockActive, setIsSelectionLockActive] = useState(false);

  const markSelectionClose = () => {
    setIsSelectionLockActive(true);
  };

  const onTriggerFocus = () => {
    setIsTriggerFocused(true);
  };

  const onTriggerBlur = () => {
    setIsTriggerFocused(false);
    setIsSelectionLockActive(false);
  };

  const isVisuallyFocused = open || isTriggerFocused || isSelectionLockActive;

  return {
    isVisuallyFocused,
    markSelectionClose,
    onTriggerFocus,
    onTriggerBlur,
  };
};
